<template>
    <survey-loader v-if="loading" cover>Downloading the latest version...</survey-loader>
    <router-view v-else />
</template>
<script src="./App.ts" lang="ts"></script>
<style lang="scss">
@import '@/variables';

*,
*::before,
*::after {
    box-sizing: border-box;
}

html,
body {
    padding: 0;
    margin: 0;
    font-family: #{$font-family};
    font-weight: $font-weight;
    color: $font-color;

    @media screen and (max-width: 768px) {
        font-size: 90%;
    }
}

#survey {
    height: 100vh;
    /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
}

body[direction='rtl'] {
    direction: rtl;
}
</style>
